import { SidebarInset, SidebarProvider } from "@grafit/design-system/components/molecules/sidebar";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { AppSidebar } from "../../components/layout/sidebar/app-sidebar";
import { useReportFeatureFlagsContext } from "../../utils/feature-flags";

export const Route = createFileRoute("/_auth/_deal")({
  component: DealFrameLayout,
});

function DealFrameLayout() {
  useReportFeatureFlagsContext();
  // the deal layout uses its own contextual sidebar for navigation,
  // so the main app sidebar must stay collapsed. The rail can still peek on hover.
  return (
    <main className="flex h-screen flex-1">
      <div className="flex flex-1 flex-col overflow-hidden">
        <SidebarProvider open={false}>
          <AppSidebar hideTrigger />
          <SidebarInset>
            <Outlet />
          </SidebarInset>
        </SidebarProvider>
      </div>
    </main>
  );
}
